/* ============================================================
   CABINOVA — PREMIUM EFFECTS JS
   Vanilla, no deps. Defer-loaded.
   Tout est isolé en try/catch — un effet qui casse n'arrête pas les autres.
   Respecte prefers-reduced-motion + désactive effets coûteux mobile.
   ============================================================ */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var isTouch = window.matchMedia && window.matchMedia("(hover: none)").matches;
  var isMobile = window.matchMedia && window.matchMedia("(max-width: 768px)").matches;

  function initReveal() {
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll("[data-cbv-reveal], [data-cbv-stagger]").forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add("is-in"); io.unobserve(entry.target); }
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.08 });
    document.querySelectorAll("[data-cbv-reveal], [data-cbv-stagger]").forEach(function (el) { io.observe(el); });
  }

  function initMaskText() {
    document.querySelectorAll("[data-cbv-mask]").forEach(function (el) {
      if (el.dataset.cbvMaskInit) return;
      el.dataset.cbvMaskInit = "1";
      el.classList.add("cbv-mask-wrap");
      var content = el.innerHTML;
      el.innerHTML = '<span class="cbv-mask-line">' + content + "</span>";
    });
  }

  function initTilt() {
    if (reduceMotion || isTouch || isMobile) return;
    document.querySelectorAll("[data-cbv-tilt]").forEach(function (el) {
      var maxTilt = parseFloat(el.dataset.cbvTilt) || 8;
      var rect;
      function onEnter() { rect = el.getBoundingClientRect(); }
      function onMove(e) {
        if (!rect) rect = el.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        var rx = (-y * maxTilt).toFixed(2);
        var ry = (x * maxTilt).toFixed(2);
        el.style.transform = "perspective(900px) rotateX(" + rx + "deg) rotateY(" + ry + "deg) translateZ(0)";
      }
      function onLeave() { el.style.transform = "perspective(900px) rotateX(0) rotateY(0) translateZ(0)"; }
      el.addEventListener("mouseenter", onEnter, { passive: true });
      el.addEventListener("mousemove", onMove, { passive: true });
      el.addEventListener("mouseleave", onLeave, { passive: true });
    });
  }

  function initMagnetic() {
    if (reduceMotion || isTouch || isMobile) return;
    document.querySelectorAll("[data-cbv-magnetic], .cbv-btn").forEach(function (el) {
      var strength = parseFloat(el.dataset.cbvMagnetic) || 14;
      function onMove(e) {
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        el.style.transform = "translate3d(" + (x / rect.width * strength).toFixed(2) + "px, " + (y / rect.height * strength).toFixed(2) + "px, 0)";
        el.style.setProperty("--mx", ((e.clientX - rect.left) / rect.width * 100) + "%");
        el.style.setProperty("--my", ((e.clientY - rect.top) / rect.height * 100) + "%");
      }
      function onLeave() { el.style.transform = "translate3d(0,0,0)"; }
      el.addEventListener("mousemove", onMove, { passive: true });
      el.addEventListener("mouseleave", onLeave, { passive: true });
    });
  }

  function initParallax() {
    if (reduceMotion || isMobile) return;
    var heroes = document.querySelectorAll('[data-parallax="true"]');
    if (!heroes.length) return;
    var ticking = false;
    function update() {
      heroes.forEach(function (h) {
        var rect = h.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var offset = -rect.top * 0.18;
        h.style.setProperty("--cbv-parallax-y", offset.toFixed(1) + "px");
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () { if (!ticking) { window.requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  function initMarquee() {
    document.querySelectorAll(".cbv-marquee").forEach(function (m) {
      var track = m.querySelector(".cbv-marquee__track");
      if (!track || track.dataset.cbvMarqueeInit) return;
      track.dataset.cbvMarqueeInit = "1";
      var clone = track.innerHTML;
      track.innerHTML = clone + clone;
    });
  }

  function initCounter() {
    if (reduceMotion) return;
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.dataset.cbvCounter, 10);
          if (isNaN(target)) return;
          var prefix = el.dataset.cbvPrefix || "";
          var suffix = el.dataset.cbvSuffix || "";
          var duration = 1600;
          var start = performance.now();
          function tick(t) {
            var p = Math.min((t - start) / duration, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            var val = Math.floor(target * eased);
            el.textContent = prefix + val.toLocaleString("fr-FR") + suffix;
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
          io.unobserve(el);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll("[data-cbv-counter]").forEach(function (el) { io.observe(el); });
  }

  function initStickyCta() {
    var cta = document.querySelector(".cbv-sticky-cta");
    if (!cta) return;
    var trigger = parseInt(cta.dataset.cbvTrigger, 10) || 500;
    function onScroll() { if (window.scrollY > trigger) { cta.classList.add("is-in"); } else { cta.classList.remove("is-in"); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function initAll() {
    try { initMaskText(); } catch (e) { console.warn("[CBV] mask", e); }
    try { initReveal(); } catch (e) { console.warn("[CBV] reveal", e); }
    try { initTilt(); } catch (e) { console.warn("[CBV] tilt", e); }
    try { initMagnetic(); } catch (e) { console.warn("[CBV] magnetic", e); }
    try { initParallax(); } catch (e) { console.warn("[CBV] parallax", e); }
    try { initMarquee(); } catch (e) { console.warn("[CBV] marquee", e); }
    try { initCounter(); } catch (e) { console.warn("[CBV] counter", e); }
    try { initStickyCta(); } catch (e) { console.warn("[CBV] sticky", e); }
  }

  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", initAll); } else { initAll(); }
})();

/* ============================================================
   CABINOVA — H1 SEO accueil
   Ajoute un H1 (titre principal) masqué visuellement UNIQUEMENT sur la page d'accueil,
   et seulement si la page n'a pas déjà de H1. Aucun changement visuel.
   ============================================================ */
(function () {
  try {
    function addHomeH1() {
      if (document.querySelector("h1")) return;
      var path = location.pathname.replace(/\/+$/, "");
      if (path !== "") return;
      var h1 = document.createElement("h1");
      h1.textContent = "Cabinova : valises cabine et bagages pour le voyage moderne";
      h1.setAttribute("style", "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;");
      document.body.insertBefore(h1, document.body.firstChild);
    }
    if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", addHomeH1); } else { addHomeH1(); }
  } catch (e) {}
})();
